import { motion } from "framer-motion";

const CHAPTERS = [
  {
    num: "01",
    title: "The Art of Discretion",
    body: "Privacy is not a feature — it is the foundation. Members and providers connect behind verified profiles, controlled visibility, and a culture where confidentiality is absolute.",
  },
  {
    num: "02",
    title: "Independently Vetted",
    body: "Every provider on Monroe Society is an independent artist of companionship — identity-verified through a trusted third party, reviewed by our team, and in complete control of her own presence.",
  },
  {
    num: "03",
    title: "Pure Advertising Independence",
    body: "We sell advertising — nothing more. Monroe Society never arranges encounters, never negotiates services, and never touches a payment between members and providers.",
  },
];

export default function Manifesto() {
  return (
    <section data-testid="manifesto-section" className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-24 lg:py-36">
      <motion.p
        className="text-xs uppercase tracking-[0.35em] text-gold/80 mb-16"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
      >
        The Monroe Standard
      </motion.p>
      <div className="space-y-0">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.num}
            data-testid={`manifesto-chapter-${c.num}`}
            className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-12 py-12 lg:py-16 border-t hairline-gold"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: i * 0.1 }}
          >
            <div className="md:col-span-2">
              <span className="font-serif text-5xl lg:text-6xl font-light gold-text">{c.num}</span>
            </div>
            <div className="md:col-span-4">
              <h3 className="font-serif text-2xl sm:text-3xl font-light text-amber-100/90 leading-snug">{c.title}</h3>
            </div>
            <div className="md:col-span-6">
              <p className="text-base text-neutral-400 font-light leading-relaxed max-w-lg">{c.body}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
